import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { CjBreadcrumb } from "../components/CjBreadcrumb";
import { CjExplainer } from "../components/CjExplainer";
import { CsvJsonTool } from "../components/CsvJsonTool";

export function CsvJsonPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <CjBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.cj_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.cj_intro()}
          </p>
        </header>

        <CsvJsonTool />

        <CjExplainer
          howTo={m.cj_howto()}
          faqs={[
            { q: m.cj_faq1_q(), a: m.cj_faq1_a() },
            { q: m.cj_faq2_q(), a: m.cj_faq2_a() },
            { q: m.cj_faq3_q(), a: m.cj_faq3_a() },
            { q: m.cj_faq4_q(), a: m.cj_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
